/**
 * Downloads a file using data in blob format
 *
 * @param file - Blob file
 * @param fileName - name of file, deafults to empty string
 */
export function downloadBlobFile(file: Blob, fileName = ''): void {
  const a = document.createElement('a');
  const url = window.URL.createObjectURL(file);

  document.body.appendChild(a);
  a.style.display = 'none';
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
